import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {name: 'humanReadable'})
export class HumanReadablePipe implements PipeTransform {
    transform(value: string): string {
        // add a space before each capital letter and then trim leading and trailing spaces
        return value.replace(/([A-Z])/g, ' $1').trim();
    }
}
